import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import type { DiscoverDetail } from "../types";
import { useDiscoverConfig } from "../config";

export function useDiscoverDetail(
  slug: string | null,
  langOverride?: string,
): { data: DiscoverDetail | null; isLoading: boolean } {
  const { i18n } = useTranslation();
  const lang = langOverride ?? i18n.language;
  const { dataSource } = useDiscoverConfig();
  const query = useQuery({
    queryKey: ["discover-detail", slug, lang],
    queryFn: () => {
      if (!slug) throw new Error("slug required");
      return dataSource.fetchDetail(slug, lang);
    },
    enabled: Boolean(slug),
    staleTime: 5 * 60 * 1000,
  });
  return {
    data: query.data ?? null,
    isLoading: query.isLoading && Boolean(slug),
  };
}
